<app-nav></app-nav>
<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col  notes-heading">
          <h4 style="padding-left:12px; ">Your Projects</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <form>
            <div class="input-group mb-3">
              <!-- Search form -->
              <form
                class="navbar-search navbar-search-light form-inline mr-sm-3"
                id="navbar-search-main"
              >
                <div
                  class="form-group mb-0"
                  [ngClass]="{ focused: focus === true }"
                >
                  <div
                    class="input-group input-group-alternative input-group-merge"
                  >
                    <div class="input-group-prepend">
                      <span class="input-group-text"
                        ><i class="fas fa-search"></i
                      ></span>
                    </div>
                    <input
                      class="form-control"
                      name="search"
                      [(ngModel)]="searchTerm"
                      (keyup)="filterNotes()"
                      placeholder="Search"
                      type="text"
                      (focus)="focus = true"
                      (blur)="focus = false"
                    />
                  </div>
                </div>
                <button
                  type="button"
                  class="close"
                  (click)="closeSearch()"
                  data-action="search-close"
                  data-target="#navbar-search-main"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </form>
            </div>
          </form>
        </div>
        <div class="col-6">
          <button
            class="btn btn-icon btn-3 btn-outline-primary float-right"
            (click)="lgModal.show()"
            type="button"
          >
            <span class="btn-inner--icon"
              ><i class="fa fa-folder-plus"></i
            ></span>
            <span class="btn-inner--text">New</span>
          </button>
          
          
        </div>
      </div>

      
    </div>
  </div>
  <hr />
  <mat-progress-bar
    class="mb-2"
    mode="indeterminate"
    style="margin-top: -2rem;"
    *ngIf="isLoading"
  ></mat-progress-bar>
  <div class="row">
    <div class="col" *ngIf="activeNotes">
      Showing {{ notesToBind.length }} of {{ notes.length }}
    </div>
    <div class="col" *ngIf="!activeNotes">
      Showing {{ notesToBind.length }} of {{ archivedNotes.length }}
    </div>
    <div class="col pull-right">
      <div class="btn-group btn-group-toggle float-right" data-toggle="buttons">
        <label
          [ngClass]="{ btn: true, 'btn-secondary': true, active: activeNotes }"
          btnRadio="left"
          tabindex="0"
          role="button"
          (click)="changeActiveNotesVisibility(true)"
        >
          Active
        </label>
        <label
          [ngClass]="{ btn: true, 'btn-secondary': true, active: !activeNotes }"
          btnRadio="Right"
          tabindex="1"
          role="button"
          (click)="changeActiveNotesVisibility(false)"
        >
          Archived
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div
      class="col-xs-1 col-sm-2 col-md-4  col-lg-4"
      *ngFor="let note of notesToBind"
    >
      <div class="card" style="margin-bottom: 2rem;margin-top:2rem;">
        <img
          class="card-img-top"
          src="..."
          alt="Card image cap"
          *ngIf="note.featuredImage"
        />
        <div class=" card-header">
          <div class=" row align-items-center">
            <div class=" col-8">
              <h5 class="mb-0 h5  card-title" *ngIf="note.title">
                {{
                  note.title.length > 50
                    ? (note.title | slice: 0:50) + ".."
                    : note.title
                }}
              </h5>
            </div>

            <div class=" col-4 text-right">
              <button
                *ngIf="activeNotes"
                (click)="archiveNote(note)"
                class="btn rounded-circle btn-icon-only btn-2 btn-outline-secondary float-right"
                type="button"
                style="margin-top:-0.1rem;"
              >
                <span class="btn-inner--icon"
                  ><i class="fa fa-archive text-muted"></i
                ></span>
              </button>
              <button
                *ngIf="!activeNotes"
                (click)="unArchive(note)"
                class="btn rounded-circle btn-icon-only btn-2 btn-outline-secondary float-right"
                type="button"
                style="margin-top:-0.1rem;"
              >
                <span class="btn-inner--icon"
                  ><i class="fa fa-inbox text-muted"></i
                ></span>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <p
            class="card-text"
            style="height:110px; overflow: hidden;"
            *ngIf="note.notes"
            [innerHtml]="
              note.notes.length > 117
                ? (note.notes | slice: 0:117) + '...'
                : note.notes
            "
          ></p>
          <p
            class="card-text"
            style="height:110px; overflow: hidden;"
            *ngIf="!note.notes"
          ></p>
          <a [routerLink]="['/editor', note.id, activeNotes]" class="btn btn-primary"
            >View</a
          >
        </div>
        <div class="card-footer text-sm font-weight-bold">
          <span style="vertical-align: sub;">Last updated {{ note.lastUpdate | dateAgo }}</span>
          <span>
            <button
              (click)="confirmDelete(note)"
              class="btn rounded-circle btn-icon-only btn-2 btn-outline-secondary float-right"
              type="button"
              style="margin-top:-0.1rem;vertical-align: super;"
            >
              <span class="btn-inner--icon"
                ><i class="fa fa-trash text-red"></i
              ></span>
            </button>
            
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div
  bsModal
  #lgModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-sizes-name1"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <h4 id="dialog-sizes-name1" class="modal-title pull-left">Large modal</h4> -->
        <button
          type="button"
          class="close pull-right"
          (click)="lgModal.hide()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container h-100">
          <div class="row h-100 justify-content-center align-items-center">
            <form class="col-12">
              <div class="form-group">
                <h3 for="projectName">
                  What do you want to call your new project?
                </h3>
                <input
                  type="text"
                  class="form-control"
                  id="projectName"
                  placeholder="Project Name"
                  [(ngModel)]="projectName"
                  name="name"
                />
              </div>
              <button
                type="button"
                class="btn btn-primary float-right"
                (click)="createProject()"
                >Create</button
              >
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
